/**
 * Default: Modules > Mindshape Cookie Consent
 *
 * @copyright 2025 i-fabrik GmbH
 * @author Tobias Garz
 */

import SelectorEngine from '../../../shared/dom/selector-engine';
import EventHandler from '../../../shared/dom/event-handler';
import Data from '../../../shared/dom/data';

import {
	lockBodyScrolling,
	unlockBodyScrolling
} from '../../../shared/utils/scroll';

import CatMap from './categories/maps';
import CatMedia from './categories/media';
import Manipulator from '../../../shared/dom/manipulator';

const CONSENT_BUTTONS         = SelectorEngine.find('[data-cookie-consent="trigger"]');
const PRIVACY_CONSENT_BUTTONS = SelectorEngine.find('.privacy-info .privacy-info__button');

let COOKIE_CONSENT = null;

// -------
// Private
// -------

const handleEsc = (event) => {
	if (event.key === 'Escape' || event.key === 'Esc') {
		document.removeEventListener('keydown', handleEsc);
		unlockBodyScrolling(COOKIE_CONSENT);
	}
};

const toggleCookieConsent = (state = true ) => {
	if(state) {
		lockBodyScrolling(COOKIE_CONSENT);
		document.addEventListener('keydown', handleEsc);
	} else {
		unlockBodyScrolling(COOKIE_CONSENT);
	}
};

const registerEvents = () => {
	window.addEventListener('cookieConsent', function () {
		initCategories();
		toggleCookieConsent(false);
	});

	// initialize all cookie toggles
	if(CONSENT_BUTTONS.length) {
		for(let button of CONSENT_BUTTONS) {
			if(Data.get(button, 'initialized')) {
				return;
			}

			EventHandler.on(button, 'click', (event) => {
				event.preventDefault();
				toggleCookieConsent(true);
			});

			Data.set(button, 'initialized', true);
		}

		// privacy-info consent click
		if(PRIVACY_CONSENT_BUTTONS.length) {
			for(let element of PRIVACY_CONSENT_BUTTONS) {
				EventHandler.on(element, 'click', () => {
					EventHandler.trigger(CONSENT_BUTTONS[0], 'click', {});
				});
			}
		}
	}
};

const isFirstAppearance = () => {
	return !window.cookieConsent.consent;
};

// -------
// Public
// -------

const checkCookieConsentStatus = () => {
	return !!window.cookieConsent;
};

const initCategories = () => {
	CatMap.init();
	CatMedia.init();
};

const init = () => {
	if(checkCookieConsentStatus()) {
		COOKIE_CONSENT = SelectorEngine.findOne('#cookie-consent');

		if(isFirstAppearance()) {
			lockBodyScrolling(COOKIE_CONSENT);
		}

		registerEvents();
		initCategories();
	}
};

// -------
// Export
// -------

export default {
	init                    : init,
	initCategories          : initCategories,
	checkCookieConsentStatus: checkCookieConsentStatus
};

